import { render, staticRenderFns } from "./permissions-denied.vue?vue&type=template&id=4d82a1b8&scoped=true"
import script from "./permissions-denied.vue?vue&type=script&lang=js"
export * from "./permissions-denied.vue?vue&type=script&lang=js"
import style0 from "./permissions-denied.vue?vue&type=style&index=0&id=4d82a1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d82a1b8",
  null
  
)

export default component.exports